import {inject, Injectable, signal} from '@angular/core';
import {AuthService} from "./auth/auth.service";
import {ApartmentService} from "./apartment.service";
import {environment} from "../../../environments/environment";
import {NotificationService} from "./notification/notification.service";
import {NativeAppService} from "./native-app/native-app.service";
import {UserService} from "./user.service";
import {PaymentService} from "./payment/payment.service";

@Injectable({
  providedIn: 'root'
})
export class DataUpdateService {
  private lastUpdateDate: Date | null = null;

  public readonly initialDataRetrieved = signal(false);

  private readonly authService = inject(AuthService);
  private readonly apartmentService = inject(ApartmentService);
  private readonly notificationService = inject(NotificationService);
  private readonly nativeService = inject(NativeAppService);
  private readonly userService = inject(UserService);
  private readonly paymentService = inject(PaymentService);

  public async updateData() {
    if (this.lastUpdateDate !== null && (new Date().getTime() - this.lastUpdateDate.getTime() < environment.dataRefreshTime)) {
      if (typeof window !== 'undefined' && window.location.pathname.includes('account/subscription')) {
        await this.authService.retrieveData();
      }

      return;
    }


    try {
      console.log("Refreshing data...");
      await this.nativeService.retrieveData();
      await this.authService.retrieveData();
      await this.apartmentService.retrieveData();
      void this.notificationService.retrieveData();
      void this.paymentService.checkTrialAvailability();
      this.lastUpdateDate = new Date();
      this.initialDataRetrieved.set(true);

      this.userService.markSeen();
      console.log("Data refreshed successfully.");

    } catch (error) {
      console.warn('DataUpdateService failed to refresh data during server render', error);
    }
  }
}
